<template>
    <el-button type="danger" size="small" circle>
        <ComTooltip content="Poista">
            <el-icon>
                <Minus></Minus>
            </el-icon>
        </ComTooltip>
    </el-button>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { Minus } from "@element-plus/icons-vue"
import ComTooltip from "../ComTooltip.vue"

export default defineComponent({
    components: {
        Minus,
        ComTooltip,
    },
})
</script>
